
import { Component, Vue } from "vue-property-decorator";
import { MetaInfo } from "vue-meta";
import SitePromoBanner from "@/components/Utility/SitePromoBanner.vue";
import CountUpNumber from "@/components/Utility/CountUpNumber.vue";
@Component({
  components: {
    SitePromoBanner,
    CountUpNumber,
  },
})
export default class About extends Vue {
  metaInfo(): MetaInfo {
    return {
      title: "關於師虎來了｜品牌故事與公司里程碑",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "師虎來了創辦人陳洛婕出身木工家庭，投入居家修繕產業科技化轉型。了解我們的品牌故事、服務理念，以及自 2019 年成立以來獲獎與成長的重要里程碑。",
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: "關於師虎來了｜品牌故事與公司里程碑",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content:
            "師虎來了創辦人陳洛婕出身木工家庭，投入居家修繕產業科技化轉型。了解我們的品牌故事、服務理念，以及自 2019 年成立以來獲獎與成長的重要里程碑。",
        },
      ],
      link: [
        {
          vmid: "canonical",
          rel: "canonical",
          href: "https://www.fdtigermaster.com/About",
        },
      ],
    };
  }

  milestoneStats = [
    { target: 25000, suffix: "+", label: "完成修繕交易" },
    { target: 220000, suffix: "+", label: "平台會員" },
    { target: 2200, suffix: "+", label: "合作師傅" },
  ];

  timelineItems = [
    { year: 2019, title: "公司成立", desc: "飛達智能股份有限公司成立，投入居家修繕服務數位化。", isFuture: false },
    { year: 2021, title: "平台正式上線", desc: "「師虎來了」投入市場，並於 2021–2022 年獲國發基金、統一證券創投、崇越科技與英濟科技投資。", isFuture: false },
    { year: 2022, title: "榮獲新創金質獎", desc: "獲經濟部第 21 屆新創事業獎「金質獎」肯定。", isFuture: false },
    { year: 2023, title: "獎項與專利雙豐收", desc: "獲台北市亮點企業「創新服務獎」與數位發展部補助，並取得報價單產生及線上驗收系統專利。", isFuture: false },
    { year: 2024, title: "品牌與創新獲肯定", desc: "榮獲品牌金舶獎、金漾獎，並入選新創 100 大。", isFuture: false },
    { year: 2025, title: "會員與服務量突破", desc: "平台會員突破 20 萬，累計完成 25,000 筆服務。", isFuture: false },
    { year: 2026, title: "拓展企業與會員服務", desc: "推動企業福委合作，PRO 會員正式上線。", isFuture: false },
    { year: 2027, title: "師虎商城上線", desc: "預計正式啟用師虎商城。", isFuture: true },
    { year: 2028, title: "啟動海外布局", desc: "預計設立海外據點，帶著台灣本土品牌穩健邁向國際。", isFuture: true },
  ];
}
